/** @jsx jsx */
import { css } from "@emotion/react";
import BgHome from '../images/LP-arabe/bg-home.png'

export const HeaderContent = css`
  background-color: #65966D;
  padding: 120px 0;
  scroll-margin-top: 70px;
  background-image: url(${BgHome});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 25%;
  .title-sec {
    margin-bottom: 56px;
    h1 {
      color: #FFF;
      font-family: Montserrat;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%;
      width: 100%;
      max-width: 495px;
      margin-top: 120px;
      margin-bottom: 24px;
      span {
        color: #FFEBD2;
      }
    }

    p {
      color: #FFF;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      margin-bottom: 40px;
    }
  }

  .button-link {
    border-radius: 16px;
    background: #F26F33;
    border: none;
    color: #FFEBD2;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    padding: 15px 56px;
    :hover {
      background-color: #CF4201;
      text-decoration: none;
    }
    :active {
      background-color: #8F2E01;
    }
  }

  .box-1 {
    border-radius: 56px;
    background: #DAE7DC;
    padding: 48px;
    img {
      margin-bottom: 48px;
    }
    h3 {
      color: #3C3C3C;
      font-family: Montserrat;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
      height: 48px;
      width: 100%;
      max-width: 200px;
    }
    p {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      height: 98px;
    }
  }
  .box-2 {
    border-radius: 56px;
    background: #FFE8DD;
    padding: 48px;
    img {
      margin-bottom: 48px;
    }
    h3 {
      color: #3C3C3C;
      font-family: Montserrat;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
      height: 48px;
      width: 100%;
      max-width: 200px;
    }
    p {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      height: 98px;
    }
  }

  .img-mobile {
    display: none;
  }

  @media (min-width: 320px) and (max-width: 767px) {
    padding-top: 80px;
    padding-bottom: 40px;
    background-image: none;
    background-color: #65966D;
    .img-mobile {
      width: 100%;
      display: flex;
    }
    .title-sec {
      h1 {
        margin-top: 24px;
        font-size: 36px;
      }
    }
  }
  @media (min-width: 768px) and (max-width: 990px) {
    
  }
  @media (min-width: 991px) and (max-width: 1199px) {
    
  }

`
